import { ImageHeading } from "./ImagesCategory";

export function vibrateMobileDevice() {
      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  // 🔔 vibration feedback for mobile devices
  if (isMobile && navigator.vibrate) {
    // navigator.vibrate(35); 
    // navigator.vibrate([15, 20]);
    // navigator.vibrate([10, 20, 10]);
    navigator.vibrate(80);
    console.log("navigator vibrate")
     
  }
    
}

export function RippleEffect(button, e){
    //  button.addEventListener('click', function (e) {
        const rect = button.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

         // Calculate farthest corner distance
         const topLeft = Math.hypot(x, y);
        const topRight = Math.hypot(rect.width - x, y);
        const bottomLeft = Math.hypot(x, rect.height - y);
        const bottomRight = Math.hypot(rect.width - x, rect.height - y);
        const maxDistance = Math.max(topLeft, topRight, bottomLeft, bottomRight);

        const ripple = document.createElement('span');
        ripple.classList.add('ripple');
        ripple.classList.add('big_btn');
        ripple.style.left = `${x}px`;
        ripple.style.top = `${y}px`;
        console.log("maxDistance", maxDistance*2)
        ripple.style.setProperty('--ripple-size', `${maxDistance * 2}px`);
        button.appendChild(ripple);

        setTimeout(() => {
          ripple.remove();
        }, 500);
    //   });
}

export function subscribeToWeekly(email, wantsReminder= true) {
  
  const formURL =
    "https://docs.google.com/forms/d/e/1FAIpQLSdEflsQnxUNyU-yZFPmb_vMlVG3pfriheTrKskX494kshvNZQ/formResponse";

  const formData = new URLSearchParams();

  // Email
  formData.append("entry.139388464", email);

  // Checkbox (send "true" if checked, else send empty)
  formData.append(
    "entry.1718701917_sentinel",
    wantsReminder ? "true" : ""
  );

  fetch(formURL, {
    method: "POST",
    mode: "no-cors",
    body: formData,
  });

  return true;
}



 export function blockOutSideElement(type){
    console.log("lock guides", type)
    const body = document.getElementsByTagName("body")[0]
    const bodyChildren = body.children
    Array.from(bodyChildren).forEach((element)=>{
      if(!element.getAttribute("guides") && !element.classList.contains("navbar")){
        
        if(type){
          // element.setAttribute("aria-hidden", true)
          // element.setAttribute("inert", true)
          body.style.overflow = 'hidden';

        }else{
          // element.removeAttribute("aria-hidden")
          // element.removeAttribute("inert")
          body.style.overflow = 'auto';
          // body.style.position = '';
        }
      }
    })
      // ✅ Set scroll block/unblock only once
  if (type) {
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
  } else {
    body.style.overflow = '';
    body.style.position = '';
  }
  }

   

  export function restoreScrollPosition(appBody){
    // let userLikeContainer = document.getElementById('userLikeContainer')
    // if(!userLikeContainer.classList.contains('show_like_container')){

    
        const scrollY = document.body.dataset.scrollY || 0;
          appBody.style.position = '';
            appBody.style.top = ``;
            appBody.style.left = '';
            appBody.style.right = '';
            appBody.style.bottom = '';
            appBody.style.removeProperty('position', 'fixed', 'important');  
        
          // Disable scroll-behavior temporarily to avoid visual scroll
          const html = document.documentElement;
          const originalScrollBehavior = html.style.scrollBehavior;
          html.style.scrollBehavior = 'auto';
          // console.log("scroll behaviour", originalScrollBehavior)
        // Instantly restore scroll position without animation
        window.scrollTo(0, parseInt(scrollY));

        // Restore scroll-behavior after restoring position
        html.style.scrollBehavior = originalScrollBehavior || 'auto';
    // }
  }

  export function capitalizeFirst(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

// export function toImageKitURL(originalUrl, width = 640, quality= 80) {
//   quality = window.innerWidth < 576 ? 50 : 80;
//   if (!originalUrl) return "";

//   const basePixabayUrl = "https://pixabay.com/get/";
//   const cdnPixabayUrl = "https://cdn.pixabay.com/";

//   let relativePath = "";

//   // Extract relative path based on known Pixabay sources
//   if (originalUrl.startsWith(basePixabayUrl)) {
//     relativePath = originalUrl.replace(basePixabayUrl, "");
//   } else if (originalUrl.startsWith(cdnPixabayUrl)) {
//     relativePath = originalUrl.replace(cdnPixabayUrl, "");
//   } else {
//     try {
//       // Handle cases where full URL is passed but doesn't match known bases
//       const url = new URL(originalUrl);
//       relativePath = url.pathname.startsWith("/") ? url.pathname.slice(1) : url.pathname;
//     } catch (err) {
//       // Fallback to the original (if it's already relative or malformed)
//       relativePath = originalUrl;
//     }
//   }
//   console.log("imagekit realtive path", relativePath, `https://ik.imagekit.io/k4vr4hitu/tr:w-${width},q-${quality},f-auto/${relativePath}`)

//   // Return the ImageKit CDN URL with transformations
//   return `https://ik.imagekit.io/k4vr4hitu/tr:w-${width},q-${quality},f-auto/${relativePath}`;
// }

function pexelsImageUrlFromImageKit(originalUrl, safeWidth, quality){
   try {

      const url =
        new URL(originalUrl);

      let relativePath =
        url.pathname.replace(
          /^\/photos\//,
          ""
        );

      return `https://ik.imagekit.io/k4vr4hitu/tr:w-${safeWidth},q-${quality},f-auto/${relativePath}`;

    } catch (err) {

      return originalUrl;

    }
}



export function toImageKitURL(originalUrl, width = 640, quality= 80) {
  quality = window.innerWidth < 576 ? 50 : 80;
  if (!originalUrl) return "";

  
  // =========================
  // ⭐ PEXELS
  // =========================

  if (
    originalUrl.includes(
      "pexels.com"
    )
  ) {
    const safeWidthforPexels = Math.min(width || 640, 1280);
    let pexelsImageUrl = pexelsImageUrlFromImageKit(originalUrl, safeWidthforPexels, quality)
    return pexelsImageUrl
   
  }



  const basePixabayUrl = "https://pixabay.com/get/";
  const cdnPixabayUrl = "https://cdn.pixabay.com/";

  let relativePath = "";

  // Extract relative path based on known Pixabay sources
  if (originalUrl.startsWith(basePixabayUrl)) {
    relativePath = originalUrl.replace(basePixabayUrl, "");
  } else if (originalUrl.startsWith(cdnPixabayUrl)) {
    relativePath = originalUrl.replace(cdnPixabayUrl, "");
  } else {
    try {
      // Handle cases where full URL is passed but doesn't match known bases
      const url = new URL(originalUrl);
      relativePath = url.pathname.startsWith("/") ? url.pathname.slice(1) : url.pathname;
    } catch (err) {
      // Fallback to the original (if it's already relative or malformed)
      relativePath = originalUrl;
    }
  }
    // ⭐ HARD CLAMP WIDTH
  const safeWidth = Math.min(width || 640, 1280);

  // Return the ImageKit CDN URL with transformations
  return `https://ik.imagekit.io/k4vr4hitu/tr:w-${safeWidth},q-${quality},f-auto/${relativePath}`;
}


export function toImageKitURLForPostCard(originalUrl, width = 640, quality = 80) {
  if (!originalUrl) return "";

  quality = window.innerWidth < 576 ? 50 : 80;

  const safeWidth = Math.min(width || 640, 1280);

  return `https://ik.imagekit.io/k4vr4hitu/tr:w-${safeWidth},q-${quality},f-auto/${originalUrl}`;
}

function toSlug(text = "") {
  return text
    .toString()
    .trim()
    .toLowerCase()
    .replace(/['"]/g, "")          // remove quotes
    .replace(/[^a-z0-9]+/g, "-")   // replace spaces & symbols with -
    .replace(/^-+|-+$/g, "");      // trim - from start/end
}


// export function hitDownload({
//   componentFrom,
//   clickedImageObj,
//   displayImage,
//   content,
//   updatedHours,
//   lastOpenedImageId,
// }) {
//    return new Promise((resolve, reject) => {
//     const imageUrl = clickedImageObj?.largeImageURL;
//     if (!imageUrl) {
//       reject("No image URL");
//       return;
//     }

//     // 🧠 Create link EARLY to preserve gesture context
//     const link = document.createElement("a");
//     link.style.display = "none";
//     link.rel = "noopener";
//     document.body.appendChild(link);

//     const categoryName =
//       componentFrom === "exploreNext" && displayImage
//         ? displayImage
//         : content?.[updatedHours?.()];

//     const slugCategory = toSlug(categoryName || "image");
//     const uniq = Date.now().toString().slice(-6);
//     const brand = "BrowseNext";

//     fetch(imageUrl + "?cb=" + Date.now(), { mode: "cors" })
//       .then((res) => res.blob())
//       .then((blob) => {
//         const url = URL.createObjectURL(blob);

//         link.href = url;
//         link.download = `${brand}-${slugCategory}-${uniq}.png`;

//         // 🧠 tiny reflow trick for iOS stability
//         // link.offsetHeight;

//         link.click();

//         setTimeout(() => {
//           URL.revokeObjectURL(url);
//           document.body.removeChild(link);
//         }, 1500);

//         // 📦 persist download info
//         if (lastOpenedImageId) {
//           const downloaded =
//             JSON.parse(localStorage.getItem("downloadedImages")) || [];
//           if (!downloaded.includes(lastOpenedImageId)) {
//             downloaded.push(lastOpenedImageId);
//             localStorage.setItem(
//               "downloadedImages",
//               JSON.stringify(downloaded)
//             );
//           }
//         }

//         resolve(true);
//       })
//       .catch(() => {
//         document.body.removeChild(link);
//         reject("Download failed");
//       });
//   });




// }


export function hitDownload({
  componentFrom,
  clickedImageObj,
  displayImage,
  content,
  updatedHours,
  lastOpenedImageId = false,
}) {
  return new Promise((resolve, reject) => {
    const imageUrl = clickedImageObj?.largeImageURL;
    if (!imageUrl) {
      reject("No image URL");
      return;
    }

    try {
      const categoryName =
        componentFrom === "exploreNext" && displayImage
          ? displayImage
          : content?.[updatedHours?.()];

      const slugCategory = toSlug(categoryName || "image");
      const uniq = Date.now().toString().slice(-6);
      const brand = "BrowseNext";

      const fileName = `${brand}-${slugCategory}-${uniq}`;

      // ✅ server-based download URL
  // const downloadUrl = `http://localhost:3001/api/download?url=${encodeURIComponent(imageUrl)}&name=${encodeURIComponent(fileName)}`;

      const downloadUrl = `/api/download?url=${encodeURIComponent(imageUrl)}&name=${encodeURIComponent(fileName)}`;

      const link = document.createElement("a");
      link.href = downloadUrl;
      // link.rel = "noopener";
      document.body.appendChild(link);

      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
      }, 1000);

      // 📦 persist download info
      if (lastOpenedImageId) {
        const downloaded =
          JSON.parse(localStorage.getItem("downloadedImages")) || [];

        if (!downloaded.includes(lastOpenedImageId)) {
          downloaded.push(lastOpenedImageId);
          localStorage.setItem(
            "downloadedImages",
            JSON.stringify(downloaded)
          );
        }
      }

      resolve(true);
    } catch (err) {
      reject("Download failed");
    }
  });
}


export function makeButtonSmall(event){    
    let shareButton = event.target;
    // let shareButton = event.currentTarget;
    
    
    if(shareButton){
      shareButton.style.backgroundColor = "#333537bd";
      // shareButton.style.backgroundColor = "#333537bd";
      // shareButton.firstElementChild.style.color = "white";
      shareButton.style.transition = "all 0.05s linear";
      shareButton.style.transform = "scale(0.9)";
      
      // shareButton.firstElementChild.style.backgroundColor = "white";
    }
    
  }
 export function makeButtonBig(event){    
    let shareButton = event?.target;
    // let shareButton = event?.currentTarget;

    if(shareButton){
      // shareButton.style.backgroundColor = "#2b2f3385";
      shareButton.style.backgroundColor = "black";
      // shareButton.style.backgroundColor = "none";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";
      // shareImage(imageUrl)
          // showBlog();
          // shareButton.style.backgroundColor = "";
      
    }
    
  }
 export function makeButtonOriginal(event){
    let shareButton = event?.target;
    // let shareButton = event?.currentTarget;
    if(shareButton){
      // shareButton.style.backgroundColor = "#2b2f3385";
      shareButton.style.backgroundColor = "black";
      // shareButton.style.backgroundColor = "none";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";         
    }    
  }
  
  export function trackEvent(name, params = {}) {    
    if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return
    
  if (typeof window !== "undefined" && typeof window.gtag === "function") {    
    window.gtag("event", name, params);
  }
}


export function extractThemeTags(baseTopic, hits = []) {
  const counts = {};
  const stop = new Set([
    baseTopic.toLowerCase(),
    "sky",
    "nature",
    "landscape",
    "outdoor",
    "travel"
  ]);

  hits.forEach(img => {
    if (!img.tags) return;

    img.tags.split(",").forEach(tag => {
      const clean = tag.trim().toLowerCase();

      if (stop.has(clean)) return;

      counts[clean] = (counts[clean] || 0) + 1;
    });
  });

  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 4)  // small set for performance
    .map(([tag]) => tag);
}

export async function fetchThemeImages(baseTopic, themes) {
  const results = [];

  for (const tag of themes) {
    const q = `${tag} ${baseTopic}`;

    const res = await fetch(
      `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(q)}&image_type=photo&per_page=3`
    );

    const data = await res.json();

    if (data.hits?.length) {
      results.push(...data.hits.slice(0, 2));
    }
  }

  return results;
}

export function isStatusImage(img) {
  if (!img) return false;

  const w = img.webformatWidth || 1;
  const h = img.webformatHeight || 1;

  const ratio = h / w;

  // Prefer vertical images (story friendly)
  return ratio > 1.2;
}

const blockedKeywords = [
  "nude",
  "sex",
  "porn",
  "xxx",
  "adult",
  "erotic",
  "nsfw"
];

export function unsafeTagValidator(tags) {
  if (!tags) return true;

  const normalized = tags.toLowerCase();

  return !blockedKeywords.some(keyword =>
    normalized.includes(keyword)
  );
}


export function likesValidator(image) {
  const likes = image?.likes || 0;
  const views = image?.views || 0;
  const downloads = image?.downloads || 0;

  return (
    likes > 750 &&                         // 🔥 primary condition
    (views > 5000 && downloads > 500)       // 🔥 secondary strong signal
  );
}

function tagScore(tags) {
  if (!tags) return 0;

  const list = tags.split(",").map(t => t.trim());

  const unique = new Set(list);

  return unique.size;
}

export function showPostReady(image) {
  return (
    unsafeTagValidator(image.tags) &&
    (
      likesValidator(image) &&     // engagement
      tagScore(image.tags) >= 5     // rich tags
    )
  );
}

export function formatLikeCount(num) {
  if (!num) return "0";

  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(".0", "") + "M";
  }

  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(".0", "") + "K";
  }

  return num.toString();
}


export function createSafePixabayQuery(slug = "") {

  const cleanedSlug = slug
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/-/g, " ")
    .replace(/[^\w\s]/gi, "")
    .replace(/\s+/g, " ")
    .trim();

  // already safe
  if (encodeURIComponent(cleanedSlug).length <= 100) {
    return cleanedSlug;
  }

  let safeQuery = "";

  for (const word of cleanedSlug.split(" ")) {

    const testQuery =
      safeQuery.length > 0
        ? `${safeQuery} ${word}`
        : word;

    if (encodeURIComponent(testQuery).length > 100) {
      break;
    }

    safeQuery = testQuery;
  }

  return safeQuery;
}

export function checkMetaInApp(){
   const userAgent = typeof navigator !== "undefined" ? navigator.userAgent.toLowerCase() : "";
const isFacebookInApp = userAgent.includes("fban") ||  userAgent.includes("fbav");
const isInstagramInApp = userAgent.includes("instagram");
const isMetaInApp = isFacebookInApp || isInstagramInApp;

return isMetaInApp
}

export function getCollectionTitle(imageTag = "") {
  const words = imageTag.toLowerCase().split(/[-\s]+/);

  const keyword = words.find((word) => ImageHeading[word]);

  if (keyword) {
    return ImageHeading[keyword]?.title;
  }

  const firstWord =
    words[0]?.charAt(0).toUpperCase() + words[0]?.slice(1);

  // return {
  //   title: `${firstWord} Inspiration`,
  //   subtitle: "Explore beautiful curated images on BrowseNext."
  // };
  return `${firstWord} Inspiration`
}
export function timeForPage(){
  const arrivalTime = new Date();
    const deviceWidth = window.innerWidth;
  const deviceType = deviceWidth <= 768 ? "mobile" : "desktop";
   const time = arrivalTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  })
  const pagePath = window.location.pathname

  return `${deviceWidth}-${deviceType}-${time}-${pagePath}`
}
export function trackImages(eventfor, imageUrl="unknow"){
  trackEvent(eventfor, {
    clickImageUrl: imageUrl,
    deviceWidth: timeForPage()
  })
}